/* SEUDA — GSAP Animations-Paket (Rituals-Look).
   Additiv: ohne JS laufen die CSS-Fallbacks (float-in/heroUp) und alles bleibt sichtbar.
   Wo GSAP übernimmt, wird die CSS-Animation des Elements abgeschaltet. */
(function () {
  'use strict';

  function init() {
    if (!window.gsap || !window.ScrollTrigger) return;
    /* Reduced Motion: gar nicht initialisieren — kein Style-Inject, keine DOM-Umbauten (30.07.) */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gsap.registerPlugin(ScrollTrigger);

    var css = document.createElement('style');
    css.textContent = '.gw{display:inline-block;overflow:hidden;vertical-align:top;padding-bottom:.12em;margin-bottom:-.12em}.gwi{display:inline-block;will-change:transform}';
    document.head.appendChild(css);

    /* Wort-Splitter: erhält <br> und <em> */
    function splitWords(sel) {
      var el = typeof sel === 'string' ? document.querySelector(sel) : sel;
      if (!el || el.dataset.gsplit) return [];
      el.dataset.gsplit = '1';
      var words = [];
      (function process(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var outer = document.createElement('span'); outer.className = 'gw';
              var inner = document.createElement('span'); inner.className = 'gwi';
              inner.textContent = part;
              outer.appendChild(inner); frag.appendChild(outer);
              words.push(inner);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            process(child);
          }
        });
      })(el);
      return words;
    }

    /* CSS-Fallback-Animation abschalten, GSAP übernimmt */
    function takeover(sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.style.animation = 'none'; });
    }

    var tracked = [];
    function reveal(targets, fromVars, trigger, startPos) {
      var t = typeof targets === 'string' ? document.querySelectorAll(targets) : targets;
      if (!t || !t.length) return null;
      fromVars = fromVars || {};
      fromVars.scrollTrigger = { trigger: trigger || t[0] || t, start: startPos || 'top 88%', once: true };
      var tw = gsap.from(t, fromVars);
      tracked.push(tw);
      return tw;
    }

    var mm = gsap.matchMedia();
    mm.add({
      reduce: '(prefers-reduced-motion: reduce)',
      mobile: '(max-width: 749px) and (prefers-reduced-motion: no-preference)',
      desktop: '(min-width: 750px) and (prefers-reduced-motion: no-preference)'
    }, function (ctx) {
      if (ctx.conditions.reduce) return;
      var isMobile = ctx.conditions.mobile;
      var drift = isMobile ? 3 : 5;
      var dist = isMobile ? 26 : 44;
      var E = 'power3.out';

      /* ===== HERO: Wort-Maske + Sequenz (ersetzt heroUp) ===== */
      var hero = document.querySelector('.hero');
      if (hero) {
        takeover('.hero-h, .hero-p, .hero-btns');
        var hw = splitWords('.hero-h');
        if (hw.length) gsap.from(hw, { yPercent: 115, duration: 1.05, ease: 'power4.out', stagger: 0.07, delay: 0.2 });
        gsap.from('.hero-p', { y: 26, autoAlpha: 0, duration: 0.9, ease: E, delay: 0.75 });
        gsap.from('.hero-btns', { y: 26, autoAlpha: 0, duration: 0.9, ease: E, delay: 0.9 });

        var heroVideo = hero.querySelector('.hero-video');
        if (heroVideo) gsap.fromTo(heroVideo, { yPercent: 0, scale: 1.12 }, { yPercent: drift, scale: 1.12, ease: 'none', force3D: true, scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.8 } });
        var heroContent = hero.querySelector('.hero-content');
        if (heroContent) gsap.fromTo(heroContent, { yPercent: 0 }, { yPercent: -(drift * 2.5), ease: 'none', force3D: true, scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.8 } });
        var hs = hero.querySelector('.hero-scroll');
        if (hs) gsap.to(hs, { autoAlpha: 0, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: '18% top', scrub: true } });
      }

      /* ===== TEASER: Tracking-Eyebrow, Wort-Maske, Formel-Zeilen ===== */
      var pt = document.querySelector('.pt-sec');
      if (pt) {
        takeover('.pt-content');
        reveal('.pt-eyebrow', { letterSpacing: '.5em', autoAlpha: 0, duration: 1.1, ease: E }, pt, 'top 78%');
        var ptw = splitWords('.pt-h');
        if (ptw.length) reveal(ptw, { yPercent: 115, duration: 0.9, ease: 'power4.out', stagger: 0.06 }, pt, 'top 78%');
        reveal('.pt-frow', { x: -34, autoAlpha: 0, duration: 0.8, ease: E, stagger: 0.14 }, pt, 'top 72%');
        reveal('.pt-cta', { y: 20, autoAlpha: 0, duration: 0.8, ease: E }, pt, 'top 62%');
        var ptBg = pt.querySelector('.pt-bg');
        if (ptBg) gsap.fromTo(ptBg, { yPercent: -drift, scale: 1.12 }, { yPercent: drift, scale: 1.12, ease: 'none', force3D: true, scrollTrigger: { trigger: pt, start: 'top bottom', end: 'bottom top', scrub: 0.8 } });
      }

      /* ===== VIER FORMELN: Karten-Stagger, Bild-Settle, Tilt ===== */
      var vf = document.querySelector('.vf-sec');
      if (vf) {
        takeover('.vf-head-left, .vf-lede, .vf-item, .vf-cream, .vf-next');
        reveal('.vf-eyebrow', { letterSpacing: '.5em', autoAlpha: 0, duration: 1.1, ease: E }, vf, 'top 80%');
        var vfw = splitWords('.vf-h');
        if (vfw.length) reveal(vfw, { yPercent: 115, duration: 0.9, ease: 'power4.out', stagger: 0.05 }, vf, 'top 80%');
        reveal('.vf-lede', { y: 22, autoAlpha: 0, duration: 0.9, ease: E }, vf, 'top 76%');

        var items = vf.querySelectorAll('.vf-item');
        if (items.length) {
          reveal(items, { y: dist, autoAlpha: 0, scale: 0.96, duration: 0.95, ease: E, stagger: 0.11, clearProps: 'transform' }, '.vf-grid', 'top 84%');
          var imgs = vf.querySelectorAll('.vf-img img');
          reveal(imgs, { scale: 1.18, duration: 1.4, ease: 'power2.out', stagger: 0.11, clearProps: 'transform' }, '.vf-grid', 'top 84%');
        }
        reveal('.vf-cream', { x: -36, autoAlpha: 0, duration: 0.9, ease: E }, '.vf-cream', 'top 90%');
        reveal('.vf-num', { scale: 0.55, autoAlpha: 0, duration: 0.9, ease: 'back.out(1.5)' }, '.vf-next', 'top 88%');
        reveal('.vf-next-p', { y: 16, autoAlpha: 0, duration: 0.8, ease: E }, '.vf-next', 'top 88%');

        /* 3D-Tilt entfernt (30.07.): kollidierte mit dem CSS-Hover (translateY) der Karten */

        var bloom = vf.querySelector('.vf-bloom');
        if (bloom) gsap.fromTo(bloom, { yPercent: -3 }, { yPercent: 3, ease: 'none', force3D: true, scrollTrigger: { trigger: vf, start: 'top bottom', end: 'bottom top', scrub: 0.8 } });
      }

      /* ===== MEER: Text füllt sich beim Scrollen (Scrub) ===== */
      var ss = document.querySelector('.ss-sec');
      if (ss) {
        takeover('.ss-eyebrow, .ss-h, .ss-p, .ss-claims');
        reveal('.ss-eyebrow', { letterSpacing: '.55em', autoAlpha: 0, duration: 1.1, ease: E }, ss, 'top 78%');
        var sw = splitWords('.ss-h');
        ss.querySelectorAll('.ss-p').forEach(function (p) { sw = sw.concat(splitWords(p)); });
        if (sw.length) {
          gsap.set(sw, { opacity: 0.16 });
          gsap.to(sw, { opacity: 1, stagger: 0.04, ease: 'none', scrollTrigger: { trigger: ss, start: 'top 70%', end: 'center 32%', scrub: 0.6 } });
        }
        reveal('.ss-claims', { y: 16, autoAlpha: 0, duration: 0.9, ease: E }, ss, 'top 45%');
        var ssv = ss.querySelector('.ss-video');
        if (ssv) gsap.fromTo(ssv, { yPercent: -drift, scale: 1.1 }, { yPercent: drift, scale: 1.1, ease: 'none', force3D: true, scrollTrigger: { trigger: ss, start: 'top bottom', end: 'bottom top', scrub: 0.8 } });
      }

      /* ===== FAQ ===== */
      var fq = document.querySelector('.fq-sec');
      if (fq) {
        takeover('.fq-head-left, .fq-lede, .fq-item, .fq-more');
        reveal('.fq-eyebrow', { letterSpacing: '.5em', autoAlpha: 0, duration: 1.1, ease: E }, fq, 'top 82%');
        var fw = splitWords('.fq-h');
        if (fw.length) reveal(fw, { yPercent: 115, duration: 0.9, ease: 'power4.out', stagger: 0.05 }, fq, 'top 82%');
        reveal('.fq-lede', { y: 20, autoAlpha: 0, duration: 0.9, ease: E }, fq, 'top 78%');
        reveal('.fq-item', { y: 26, autoAlpha: 0, duration: 0.75, ease: E, stagger: 0.08 }, '.fq-list', 'top 84%');
        reveal('.fq-more', { autoAlpha: 0, duration: 0.9, ease: E }, '.fq-more', 'top 92%');
      }

      /* ===== KONTAKT ===== */
      var rq = document.querySelector('.rq-sec');
      if (rq) {
        takeover('.rq-card');
        reveal('.rq-eyebrow', { letterSpacing: '.5em', autoAlpha: 0, duration: 1.1, ease: E }, rq, 'top 82%');
        var rw = splitWords('.rq-h');
        if (rw.length) reveal(rw, { yPercent: 115, duration: 0.9, ease: 'power4.out', stagger: 0.06 }, rq, 'top 82%');
        reveal('.rq-desc', { y: 20, autoAlpha: 0, duration: 0.9, ease: E }, rq, 'top 78%');
        reveal('.rq-card', { y: dist, autoAlpha: 0, scale: 0.985, duration: 1, ease: E }, rq, 'top 74%');
        reveal('.rq-fine', { autoAlpha: 0, duration: 0.9, ease: E }, rq, 'top 60%');
      }

      /* Failsafe: falls ein Trigger übersprungen wurde, Endzustand erzwingen */
      setTimeout(function () {
        ScrollTrigger.refresh();
        tracked.forEach(function (tw) {
          var st = tw.scrollTrigger;
          if (st && tw.progress() === 0 && st.progress > 0) tw.progress(1);
        });
      }, 6000);
    });

    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
